require('./emitedTransfersLiquidationTable.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @ utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;

// @ constants
const { 
    TRANSFER_LIQUIDATION_COMMISSION_COSTS_SHARED_ID,
    TRANSFER_LIQUIDATION_COMMISSION_COSTS_OWNER_ID,
    TRANSFER_LIQUIDATION_COMMISSION_COSTS_BENEFICIARY_ID,
    TRANSFER_LIQUIDATION_COMMISSION_COSTS_INCOMPLETE_INFO_ID,
    TRANSFER_LIQUIDATION_MAIL_COSTS_ID,
    TRANSFER_LIQUIDATION_SWIFT_COSTS_ID,
    TRANSFER_LIQUIDATION_CONVERSION_ID,
} = require('constants/index');


class EmitedTransfersLiquidationTable extends React.Component {

    buildTableHeaders() {
        return (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell asHeader={true} className="emited-transfers-liquidation-table__detail-row-cell--left">
                        <FormattedText value="transfersLiquidationDetails-concept" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="emited-transfers-liquidation-table__detail-row-cell--center">
                        <FormattedText value="transfersLiquidationDetails-ownerCosts" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="emited-transfers-liquidation-table__detail-row-cell--right">
                        <FormattedText value="transfersLiquidationDetails-beneficiaryCosts" />
                    </OKTableCell>
                </OKTableRow>
            </thead>
        );
    }

    buildAmountElement(amount) {
        const language = getLanguage();
        const amountObject = getPlainAmountObject(amount);
        const amountObjectFormatted = formatAmountObject(amountObject, true);

        return (
            <OneLineSymbolAmount
                amountObject={amountObject}
                language={language}
                amountObjectFormatted={amountObjectFormatted}
            />
        );
    }

    buildInfoRow(conceptKey, row, desktopRowClasses = '') {
        const { immScreen, immTransaction } = this.props;
        const immLiquidationsDetails = immTransaction.getIn(['liquidations', 'liquidationDetails']);
        const ownerCostsElement = this.buildAmountElement(immLiquidationsDetails.getIn([row, 'ownerCosts']));
        const beneficiaryCostsElement = this.buildAmountElement(immLiquidationsDetails.getIn([row, 'beneficiaryCosts']));
        let infoRow;

        if (immScreen.get('isMobile')) {
            infoRow = (
                <React.Fragment>
                    <OKTableRow className="emited-transfers-liquidation-table__detail-row-mobile">
                        <OKTableCell
                            className="emited-transfers-liquidation-table__detail-cell-mobile emited-transfers-liquidation-table__detail-cell-mobile--no-bottom-padding emited-transfers-liquidation-table__detail-cell-mobile--extra-top-padding"
                            colSpan={2}
                        >
                            <FormattedText value={conceptKey} />
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile emited-transfers-liquidation-table__detail-cell-mobile--extra-bottom-padding">
                            <FormattedText value="transfersLiquidationDetails-ownerCosts" />:<br />
                            <FormattedText value="transfersLiquidationDetails-beneficiaryCosts" />:
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile text-right">
                            {ownerCostsElement}<br />
                            {beneficiaryCostsElement}
                        </OKTableCell>
                    </OKTableRow>
                </React.Fragment>
            );
        } else {
            infoRow = (
                <OKTableRow className={desktopRowClasses}>
                    <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell--left">
                        <FormattedText value={conceptKey} />
                    </OKTableCell>
                    <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell--center">
                        {ownerCostsElement}
                    </OKTableCell>
                    <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell--right">
                        {beneficiaryCostsElement}
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return infoRow;
    }

    buildTotalCommissionsRow() {
        const { immScreen, immTransaction } = this.props;
        const totalOwnerCostsElement = this.buildAmountElement(immTransaction.getIn(['liquidations', 'owner']));
        const totalBeneficiaryCostsElement = this.buildAmountElement(immTransaction.getIn(['liquidations', 'beneficiary']));
        const totalOwedCostsElement = this.buildAmountElement(immTransaction.getIn(['liquidations', 'owed']));
        let totalCommissionsRow;

        if (immScreen.get('isMobile')) {
            totalCommissionsRow = (
                <React.Fragment>
                    <OKTableRow className="emited-transfers-liquidation-table__detail-row-mobile">
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile emited-transfers-liquidation-table__detail-cell-mobile--no-bottom-padding emited-transfers-liquidation-table__detail-cell-mobile--extra-top-padding">
                            <FormattedText value="transfersLiquidationDetails-transfersLiquidationDetails_commisionsCostsTotalOwner" />
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile text-right emited-transfers-liquidation-table__detail-cell-mobile--no-bottom-padding emited-transfers-liquidation-table__detail-cell-mobile--extra-top-padding">
                            {totalOwnerCostsElement}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow className="emited-transfers-liquidation-table__detail-row-mobile">
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile emited-transfers-liquidation-table__detail-cell-mobile--no-bottom-padding">
                            <FormattedText value="transfersLiquidationDetails-transfersLiquidationDetails_commisionsCostsTotalBeneficiary" />
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile text-right emited-transfers-liquidation-table__detail-cell-mobile--no-bottom-padding">
                            {totalBeneficiaryCostsElement}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow className="emited-transfers-liquidation-table__detail-row-mobile">
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile emited-transfers-liquidation-table__detail-cell-mobile--no-bottom-padding">
                            <FormattedText value="transfersLiquidationDetails-owedTotal" />
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-cell-mobile text-right emited-transfers-liquidation-table__detail-cell-mobile--no-bottom-padding">
                            {totalOwedCostsElement}
                        </OKTableCell>
                    </OKTableRow>
                </React.Fragment>
            );
        } else {
            totalCommissionsRow = (
                <React.Fragment>
                    <OKTableRow className="emited-transfers-liquidation-table__detail-row">
                        <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell emited-transfers-liquidation-table__detail-row-cell--left">
                            <FormattedText value="transfersLiquidationDetails-commisionsCostsTotal" />
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell emited-transfers-liquidation-table__detail-row-cell--center">
                            {totalOwnerCostsElement}
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell emited-transfers-liquidation-table__detail-row-cell--right">
                            {totalBeneficiaryCostsElement}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow className="emited-transfers-liquidation-table__detail-row">
                        <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell emited-transfers-liquidation-table__detail-row-cell--left">
                            <FormattedText value="transfersLiquidationDetails-owedTotal" />
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell emited-transfers-liquidation-table__detail-row-cell--center">
                            {totalOwedCostsElement}
                        </OKTableCell>
                        <OKTableCell className="emited-transfers-liquidation-table__detail-row-cell emited-transfers-liquidation-table__detail-row-cell--right" />
                    </OKTableRow>
                </React.Fragment>
            );
        }

        return totalCommissionsRow;
    }

    buildTableSection() {
        const { immScreen, immTransaction } = this.props;
        const immLiquidationsDetails = immTransaction.getIn(['liquidations', 'liquidationDetails']);
        const totalCommissionsRow = this.buildTotalCommissionsRow();
        const commissionIds = [
            TRANSFER_LIQUIDATION_COMMISSION_COSTS_SHARED_ID,
            TRANSFER_LIQUIDATION_COMMISSION_COSTS_OWNER_ID,
            TRANSFER_LIQUIDATION_COMMISSION_COSTS_BENEFICIARY_ID
        ];
        const commissionSelected = commissionIds.find(id => immLiquidationsDetails.has(id));
        let tableClassName;
        let tableHeaders;
        let comissionCostsContentRow;
        let conversionCostsContentRow;
        let swiftCostsContentRow;
        let mailCostsContentRow;
        let incompleteInfoContentRow;

        if (immScreen.get('isMobile')){
            tableClassName = 'emited-transfers-liquidation-table__table-mobile';
        } else {
            tableHeaders = this.buildTableHeaders();
        }

        if (!!commissionSelected) {
            comissionCostsContentRow = this.buildInfoRow('transfersLiquidationDetails-commissionCosts', commissionSelected);
        }

        if (immLiquidationsDetails.has(TRANSFER_LIQUIDATION_CONVERSION_ID)) {
            conversionCostsContentRow = this.buildInfoRow('transfersLiquidationDetails-conversionCosts', TRANSFER_LIQUIDATION_CONVERSION_ID, 'emited-transfers-liquidation-table__final-row');
        }

        if (immLiquidationsDetails.has(TRANSFER_LIQUIDATION_SWIFT_COSTS_ID)) {
            swiftCostsContentRow = this.buildInfoRow('transfersLiquidationDetails-swiftCosts', TRANSFER_LIQUIDATION_SWIFT_COSTS_ID);
        }

        if (immLiquidationsDetails.has(TRANSFER_LIQUIDATION_MAIL_COSTS_ID)) {
            mailCostsContentRow = this.buildInfoRow('transfersLiquidationDetails-mailCosts', TRANSFER_LIQUIDATION_MAIL_COSTS_ID, 'emited-transfers-liquidation-table__final-row');
        } 
        
        if (immLiquidationsDetails.has(TRANSFER_LIQUIDATION_COMMISSION_COSTS_INCOMPLETE_INFO_ID)) {
            incompleteInfoContentRow = this.buildInfoRow('transfersLiquidationDetails-incompleteInfoCommission', TRANSFER_LIQUIDATION_COMMISSION_COSTS_INCOMPLETE_INFO_ID, 'emited-transfers-liquidation-table__final-row');
        }
        
        return (
            <section className="emited-transfers-liquidation-table__table">
                <OKTable className={tableClassName}>
                    {tableHeaders}
                    <tbody>
                        {comissionCostsContentRow}
                        {swiftCostsContentRow}
                        {mailCostsContentRow}
                        {conversionCostsContentRow}
                        {incompleteInfoContentRow}
                        {totalCommissionsRow}
                    </tbody>
                </OKTable>
            </section>
        );
    }

    render() {
        const { immScreen } = this.props;
        const tableSection = this.buildTableSection();
        const headerText = <FormattedText value="transfersLiquidationDetails-liquidationDetails" />;
        let tableBlock;

        if (immScreen.get('isMobile')) {
            tableBlock = (
                <React.Fragment>
                    <header className="emited-transfers-liquidation-table__header-mobile">{headerText}</header>
                    {tableSection}
                </React.Fragment>
            );
        } else {
            tableBlock = (
                <section className="emited-transfers-liquidation-table">
                    <header className="emited-transfers-liquidation-table__header">{headerText}</header>
                    {tableSection}
                </section>
            );
        }

        return tableBlock;
    }
}

EmitedTransfersLiquidationTable.propTypes = {
    accountId: PropTypes.string.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
};

module.exports = EmitedTransfersLiquidationTable;
